import Colors from '@/constants/Colors';
import { Avatar, Tag } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { StyledActivityLinkItem } from './ActivityLinkItem.styled';
import ActivityTypeIcon from '../ActivityTypeIcon/ActivityTypeIcon';

export default function ActivityLinkItem({
  activity,
  urlPrefix = '',
  imageSize = 200,
  allowFreeLabel = true,
  showIcon = false,
}) {
  return (
    <StyledActivityLinkItem imageSize={imageSize}>
      <Link href={`${urlPrefix}/${activity.slug}`}>
        <a>
          <div className="activity-image">
            {activity.theme?.thumb ? (
              <Image
                src={activity.theme?.thumb}
                alt={activity.name}
                layout="fill"
                objectFit="cover"
              />
            ) : (
              <Avatar size={imageSize} />
            )}
            {activity.free && allowFreeLabel && (
              <Tag color={Colors.green} className="tag">
                FREE
              </Tag>
            )}
          </div>
          {showIcon ? (
            <div className="activity-link-item-icon">
              <ActivityTypeIcon
                type={activity.type}
                color="white"
                withCircle
                circleColor={Colors.activityTypeColors[activity.type]}
                size={18}
                width={35}
                height={35}
              />
            </div>
          ) : null}
          <div className="activity-name">{activity.name}</div>
          <div className="activity-english-name">{activity.englishName}</div>
        </a>
      </Link>
    </StyledActivityLinkItem>
  );
}
